import type React from "react";
import { useId } from "react";
import { useTranslation } from "react-i18next";

import type { CountryCode } from "@krea/shared/types/common";

import { TextInput } from "../TextInput";

interface IEmailInputProps {
  value: string;
  countryCode: CountryCode;
  touched: boolean;
  error?: string;
  label?: string;
  placeholder?: string;
  /** Input id; defaults to a generated unique id. */
  id?: string;
  onBlur?: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  dataTestId?: string;
}

export const EmailInput = ({
  value,
  countryCode,
  touched,
  error,
  label,
  placeholder,
  id,
  onBlur,
  onChange,
  dataTestId,
}: IEmailInputProps) => {
  const { t } = useTranslation("formFields");
  const generatedId = useId();

  const defaultPlaceholder =
    (
      t("formFields.emailPlaceholder", {
        returnObjects: true,
      }) as Record<string, string>
    )[countryCode] ?? "";

  return (
    <TextInput
      id={id ?? generatedId}
      type="email"
      name="email"
      dataTestId={dataTestId}
      label={label ?? t("formFields.emailLabel")}
      placeholder={placeholder ?? defaultPlaceholder}
      autoComplete="on"
      value={value || ""}
      error={touched && error ? error : undefined}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};
